/* Native links stay available without JavaScript; enhance only the phone menu. */
const toggle = document.querySelector('.mx-menu-toggle');
const navigation = document.querySelector('#mx-primary-navigation');

if (toggle && navigation) {
  const phone = window.matchMedia('(width < 44rem)');
  const setOpen = (open) => {
    toggle.hidden = !phone.matches;
    navigation.hidden = phone.matches && !open;
    toggle.setAttribute('aria-expanded', String(phone.matches && open));
  };
  const reset = () => {
    const focusWasInside = navigation.contains(document.activeElement);
    const focusWasToggle = document.activeElement === toggle;
    setOpen(false);
    if (phone.matches && focusWasInside) toggle.focus();
    if (!phone.matches && focusWasToggle) navigation.querySelector('a')?.focus();
  };
  toggle.addEventListener('click', () => setOpen(navigation.hidden));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && phone.matches && !navigation.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });
  phone.addEventListener('change', reset);
  reset();
}

const livingNav = document.querySelector('#mx-living-navigation');
if (livingNav) {
  const menu = livingNav.querySelector('details');
  const summary = menu.querySelector('summary');
  let pinned = false;
  const close = () => { menu.open = false; pinned = false; };
  livingNav.classList.add('mx-enhanced');
  summary.addEventListener('click', (event) => {
    event.preventDefault();
    if (pinned) close();
    else {
      menu.open = true;
      pinned = true;
      if (event.detail === 0) livingNav.querySelector('.mx-living-secondary a')?.focus();
    }
  });
  summary.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse' && window.matchMedia('(hover: hover)').matches) menu.open = true;
  });
  livingNav.addEventListener('pointerleave', () => {
    if (!pinned && !livingNav.contains(document.activeElement)) close();
  });
  document.addEventListener('click', (event) => {
    if (!livingNav.contains(event.target)) close();
  });
  livingNav.addEventListener('focusout', (event) => {
    if (event.relatedTarget && !livingNav.contains(event.relatedTarget)) close();
  });
  livingNav.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') { close(); summary.focus(); event.preventDefault(); }
  });
}
